import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelValueListFormComponent } from './label-value-list-form/label-value-list-form.component';
import { LabelValueEditModalComponent } from './label-value-edit-modal/label-value-edit-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [LabelValueListFormComponent, LabelValueEditModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
  ],
  exports: [LabelValueListFormComponent, LabelValueEditModalComponent],
})
export class LabelValueListModule {}
